import React from 'react'
import { Route, Navigate } from 'react-router-dom'

const Redirect = (props) => {
  return (
    <Route
      index={true}
      path="/"
      render={() => <Navigate to={props.to} />}
      {...props}
    />
  )
}

export default Redirect
